require('../styles.css');
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/icons/monochrome/IconTrophy.tsx
var IconTrophy_exports = {};
__export(IconTrophy_exports, {
  default: () => IconTrophy_default
});
module.exports = __toCommonJS(IconTrophy_exports);

// src/assets/monochrome/trophy.svg
var import_jsx_runtime = require("react/jsx-runtime");
var SvgTrophy = (props) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", { d: "M17.4993 3.33464H14.9993V2.5013C14.9993 2.28029 14.9116 2.06833 14.7553 1.91205C14.599 1.75577 14.387 1.66797 14.166 1.66797H5.83268C5.61167 1.66797 5.39971 1.75577 5.24343 1.91205C5.08715 2.06833 4.99935 2.28029 4.99935 2.5013V3.33464H2.49935C2.27834 3.33464 2.06637 3.42243 1.91009 3.57871C1.75381 3.73499 1.66602 3.94695 1.66602 4.16797V6.66797C1.66602 7.55202 2.01721 8.39987 2.64233 9.02499C3.26745 9.65011 4.11529 10.0013 4.99935 10.0013H6.28268C7.03646 10.8423 8.05273 11.4033 9.16602 11.593V13.3346H8.33268C7.66964 13.3346 7.03376 13.598 6.56492 14.0669C6.09607 14.5357 5.83268 15.1716 5.83268 15.8346V17.5013C5.83268 17.7223 5.92048 17.9343 6.07676 18.0906C6.23304 18.2468 6.445 18.3346 6.66602 18.3346H13.3327C13.5537 18.3346 13.7657 18.2468 13.9219 18.0906C14.0782 17.9343 14.166 17.7223 14.166 17.5013V15.8346C14.166 15.1716 13.9026 14.5357 13.4338 14.0669C12.9649 13.598 12.3291 13.3346 11.666 13.3346H10.8327V11.593C11.946 11.4033 12.9622 10.8423 13.716 10.0013H14.9993C15.8834 10.0013 16.7313 9.65011 17.3564 9.02499C17.9815 8.39987 18.3327 7.55202 18.3327 6.66797V4.16797C18.3327 3.94695 18.2449 3.73499 18.0886 3.57871C17.9323 3.42243 17.7204 3.33464 17.4993 3.33464ZM4.99935 8.33464C4.55732 8.33464 4.1334 8.15904 3.82084 7.84648C3.50828 7.53392 3.33268 7.11 3.33268 6.66797V5.0013H4.99935V6.66797C5.00118 7.23606 5.09982 7.79968 5.29102 8.33464H4.99935ZM11.666 15.0013C11.887 15.0013 12.099 15.0891 12.2553 15.2454C12.4116 15.4017 12.4993 15.6136 12.4993 15.8346V16.668H7.49935V15.8346C7.49935 15.6136 7.58715 15.4017 7.74343 15.2454C7.89971 15.0891 8.11167 15.0013 8.33268 15.0013H11.666ZM13.3327 6.66797C13.3327 7.55202 12.9815 8.39987 12.3564 9.02499C11.7313 9.65011 10.8834 10.0013 9.99935 10.0013C9.11529 10.0013 8.26745 9.65011 7.64233 9.02499C7.01721 8.39987 6.66602 7.55202 6.66602 6.66797V3.33464H13.3327V6.66797ZM16.666 6.66797C16.666 7.11 16.4904 7.53392 16.1779 7.84648C15.8653 8.15904 15.4414 8.33464 14.9993 8.33464H14.7077C14.8989 7.79968 14.9975 7.23606 14.9993 6.66797V5.0013H16.666V6.66797Z", fill: "#676F7E" }) });
var trophy_default = SvgTrophy;

// src/Wrappers/helpers.ts
var getIconBaseCssVariables = ({
  size,
  rotate,
  transitionDuration
}) => {
  return {
    "--icon-size": size ? `${size}px` : "100%",
    "--icon-rotate": rotate ? `${rotate}deg` : "0deg",
    // Browser cannot handle multiple transitions on the same property if another variable (e.g. --transition-duration)
    // is defined on another element.
    "--icon-transition-fill": transitionDuration ? `fill ${transitionDuration} ease` : "none",
    "--icon-transition-transform": transitionDuration ? `transform ${transitionDuration} ease` : "none"
  };
};
var getIconColoringCssVariables = ({
  state,
  color,
  activeColor
}) => {
  return {
    "--icon-color": state === "active" ? activeColor : color,
    "--icon-active-color": state === "disabled" || !activeColor ? color : activeColor
  };
};

// src/Wrappers/IconWrapper.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var getWrapperStyles = (props) => ({
  ...getIconBaseCssVariables(props),
  ...getIconColoringCssVariables(props)
});
var IconWrapper = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    "div",
    {
      className: "ui-icon-size-wrapper ui-icon-coloring-wrapper",
      style: getWrapperStyles(props),
      children: props.children
    }
  );
};

// src/icons/monochrome/IconTrophy.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var IconTrophy = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(IconWrapper, { ...props, children: /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(trophy_default, {}) });
};
IconTrophy.displayName = "IconTrophy";
var IconTrophy_default = IconTrophy;
